<template>
  <div class="project-one-paint-and-theme-view" qaid="project-one-paint-and-theme-view">
    <project-one-paint-and-theme-picker v-if="!isThemeSelected" :base-properties="bpData" />
    <project-one-paint-and-theme-customizer v-else :base-properties="bpData" />
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import ProjectOnePaintAndThemePicker from '@/projectOne/components/paintAndTheme/ProjectOnePaintAndThemePicker';
import ProjectOnePaintAndThemeCustomizer from '@/projectOne/components/paintAndTheme/ProjectOnePaintAndThemeCustomizer';

export default {
  components: {
    ProjectOnePaintAndThemePicker,
    ProjectOnePaintAndThemeCustomizer,
  },

  computed: {
    ...mapState('projectOne', ['isThemeSelected', 'hasSelectionsChanged', 'selections']),
  },

  created() {
    this.setPageLoading(false);
    if (this.selections?.length) {
      this.fetchBikeEta({buildId: this.$route.params.buildId, selections: this.selections});
    } else {
      this.fetchBikeEta({buildId: this.$route.params.buildId});
    }

    // If there is a presetPK or a config buildId, go straight to the customizer view (vs. theme selector)
    if (this.$route.query?.presetPK || this.$route.params?.buildId?.startsWith('P-')) {
      this.setIsThemeSelected(true);
    }
  },

  methods: {
    ...mapActions('projectOne', ['fetchBikeEta']),
    ...mapMutations('projectOne', ['setPageLoading', 'setIsThemeSelected']),
  },
};
</script>
